import React from "react";
import "../../index.css";
import { HashLink as Link } from "react-router-hash-link";
import kudokumock from "../../img/kudoku-mock.svg";
import relearn from "../../img/relearn.png";
import akopangan from "../../img/akopangan-mock.png";
import thomsonmock from "../../img/thomson-mock.png";
import amigo from "../../img/amigo-new.png";

function Work() {
  return (
    <section id="work">
      <section className="work-section-desktop flex flex-col gap-y-4">
        <section className="work-header-sec bg-primary px-5 py-2 lg:px-20">
          <h1 className="work-header text-white text-subhead font-semibold">
            Selected works:
          </h1>
        </section>

        <section className="kudoku selected-work px-5 py-2 lg:px-20">
          <h2 className="kudoku-title text-subhead font-bold">
            Co-creating{" "}
            <u>
              <a
                href="https://kudoku.id/"
                target="_blank"
                class="link"
                rel="noopener noreferrer"
              >
                Kudoku,
              </a>
            </u>
            <br />a web platform to help people manage their finances.
          </h2>

          <section className="kudoku-description">
            <section className="kudoku-explanation flex flex-col lg:flex-row lg:items-center lg:gap-x-10">
              <section className="flex flex-col gap-y-5">
                <ul className="kudoku-details pt-5 pb-4">
                  <li className="text-body">
                    Role: Co-founder & product designer
                  </li>
                  <li className="text-body">Date: 2022</li>
                  <li className="text-body">
                    Industry: Financial technology (fintech)
                  </li>
                  <li className="text-body">
                    <a
                      href="https://www.notion.so/Kudoku-df533e50b00c464297a52d62712b74f1?pvs=4"
                      target="_blank"
                      class="link-case text-button"
                      rel="noopener noreferrer"
                    >
                      View case study
                    </a>
                  </li>
                </ul>
                <p className="text-body">
                  Kudoku is the second tech company that I built. I teamed up
                  with my colleagues to solve our own problem on managing
                  personal finance since it's quite hard for us to find a
                  perfect app to manage our finance condition.
                </p>
                <p className="text-body">
                  And when we start going out interviewing people (like our
                  friends and colleagues) about their financial life, it turns
                  out that a lot of them feel the same. The current tools just
                  don’t suit them and they actively searching for a financial
                  tools to help them.
                </p>
                <p className="text-body">
                  Kudoku is still in early stage, but we’re proud that we’ve
                  acquired more than 50 users in waiting list within 2 weeks
                  after we launch our landing page.
                </p>
              </section>
              <img
                class="kudoku-image mt-10 lg:w-auto lg:h-80"
                src={kudokumock}
                alt="kudoku"
              ></img>
            </section>
          </section>
        </section>

        <section className="relearn selected-work bg-background px-5 py-8 lg:px-20">
          <h2 className="relearn-title text-subhead font-bold">
            Designing Relearn App, <br />a learning app dedicated to corporate
            workers.
          </h2>

          <section className="relearn-description">
            <section className="relearn-explanation-1 flex flex-col lg:items-start">
              <section className="flex flex-col gap-y-5">
                <ul className="relearn-details pt-5 pb-4">
                  <li className="text-body">Role: UI/UX</li>
                  <li className="text-body">Date: 2022</li>
                  <li className="text-body">
                    Industry: Education technology (edutech)
                  </li>
                  <li className="text-body">
                    <a
                      href="https://www.notion.so/Relearn-13673660f6aa407cb900bba89aa825d3?pvs=4"
                      target="_blank"
                      class="link-case text-button"
                      rel="noopener noreferrer"
                    >
                      View case study
                    </a>
                  </li>
                </ul>
                <p className="text-body">
                  Some corporate employees are having difficulties on studying
                  entrepreneurial skill due to the energy and time limitation,
                  since they need to commute everyday to work. Relearn app, is
                  an app which blends the intuitive UX aspects found in products
                  like Coursera and Udemy.
                </p>
                <p className="text-body">
                  Relearn app will enable them to increase their entrepreneurial
                  knowledge by providing a specific learning material and
                  insights that match with their interest and it will easily
                  accessible to use Relearn while commuting to work. By
                  designing a both compact and accessible interface, we feel
                  that our target user can use it.
                </p>
              </section>
              <img
                class="kudoku-image mt-10 lg:w-auto lg:h-80 lg:items-start"
                src={relearn}
                alt="relearn"
              ></img>
              <p className="text-body mt-10">
                {" "}
                My work for Relearn app includes the entire UX process from
                empathize stage to handing off the product to engineers. Relearn
                app is still on early stage product and needs many iteration to
                reach the product market fit stage in the market. However, this
                project inspire me to do my best work as a UX designer.
              </p>
            </section>
          </section>
        </section>

        <section className="thomson selected-work bg-background px-5 py-8 lg:px-20">
          <h2 className="thomson-title text-subhead font-bold">
            Designing{" "}
            <u>
              <a
                href="https://thomsonradionet.com/"
                target="_blank"
                class="link"
                rel="noopener noreferrer"
              >
                Thomson Radio Network website,
              </a>
            </u>
            <br />a radio company based on Indonesia.
          </h2>

          <section className="thomson-description">
            <section className="thomson-explanation flex flex-col gap-x-5  lg:items-start lg:gap-x-10">
              <section className="flex flex-col gap-y-5">
                <ul className="thomson-details pt-5 pb-4">
                  <li className="text-body">Role: UI/UX & web developer</li>
                  <li className="text-body">Date: 2022</li>
                  <li className="text-body">Industry: Radio</li>
                  <li className="text-body">
                    <a
                      href="https://www.notion.so/Thomson-Radio-Network-TRN-4098a01a17eb461498436ad1b64ccbfe?pvs=4"
                      target="_blank"
                      class="link-case text-button"
                      rel="noopener noreferrer"
                    >
                      View case study
                    </a>
                  </li>
                </ul>
                <p className="text-body">
                  Thomson Radio Network (TRN) is a set of network which consist
                  of 50 radio branches across Indonesia. TRN considers their
                  online presence and we're working together to develop a
                  massive website which covers all the 50 radios of their
                  network. The visitor should be able to live-stream and see
                  various amount of contents in each of the radio station (and
                  yes, it’s a 50 radios in one website).
                </p>
                <p className="text-body">
                  My work starts from understanding the problem of radio website
                  visitor and finish my work with delivering the website using
                  Wordpress.
                </p>
              </section>
              <img
                class="thomson-image kudoku-image mt-10 lg:w-96 lg:h-auto"
                src={thomsonmock}
                alt="thomson"
              ></img>
            </section>
          </section>
        </section>

        <section className="amigo selected-work px-5 py-8 lg:px-20">
          <h2 className="amigo-title text-subhead font-bold">
            Designing Amigo App,
            <br />a restaurant app for online order & reservation.
          </h2>

          <section className="amigo-description">
            <section className="amigo-explanation flex flex-col lg:flex-row lg:items-center lg:gap-x-10">
              <section className="flex flex-col gap-y-5">
                <ul className="amigo-details pt-5 pb-4">
                  <li className="text-body">Role: UI/UX</li>
                  <li className="text-body">Date: November 2021</li>
                  <li className="text-body">Industry: food & beverages</li>
                  <li className="text-body">
                    <a
                      href="https://www.notion.so/Amigo-app-91b13a44da1444d88f57a4f8a322d639?pvs=4"
                      target="_blank"
                      class="link-case text-button"
                      rel="noopener noreferrer"
                    >
                      View case study
                    </a>
                  </li>
                </ul>
                <p className="text-body">
                  Amigo is a medium-sized brick & mortar restaurant who have
                  several branches around the town. To meet the demand of their
                  customers, Amigo starting to consider to make an app which
                  enable their customer to explore menu & restaurant location,
                  order menu, reserve table, and pickup orders.
                </p>
                <p className="text-body">
                  To start this project, I really need to work with the owners
                  and trying to understand their problem. Besides that, being a
                  customer-centric is crucial in this project. The work started
                  from doing user research by talking with existing customer and
                  also people who love to go to restaurant. The final result is
                  HiFi prototype and mockup for Amigo restaurant app.
                </p>
                <p className="text-body">
                  Amigo restaurant is a family-owned business. Most of the
                  owners doesn't care well about using technology to help
                  growing their business. I learn so much about working with
                  non-technology background person in terms of delivering my
                  empathy and how I explain things in very simple way.
                </p>
              </section>
              <img
                class="amigo-image kudoku-image mt-10 lg:w-auto lg:h-96"
                src={amigo}
                alt="amigo"
              ></img>
            </section>
          </section>
        </section>

        <section className="akopangan selected-work px-5 py-8 lg:px-20">
          <h2 className="akopangan-title text-subhead font-bold">
            Creating{" "}
            <u>
              <a
                href="https://akopangan.com/"
                target="_blank"
                class="link"
                rel="noopener noreferrer"
              >
                Akopangan.com,
              </a>
            </u>
            <br />a company that produces and supplies fresh agricultural
            products to business owners and consumers.
          </h2>

          <section className="akopangan-description">
            <section className="akopangan-explanation flex flex-col lg:flex-row lg:items-center lg:gap-x-10">
              <section className="flex flex-col gap-y-5">
                <ul className="akopangan-details pt-5 pb-4">
                  <li className="text-body">Role: UI/UX & Web developer</li>
                  <li className="text-body">Date: June - July 2022</li>
                  <li className="text-body">Industry: Agriculture</li>
                </ul>
                <p className="text-body">
                  Akopangan (AKO) is expected to be a solution to the problem of
                  agriculture and consumers who need a quick supply of staples.
                  The products sold include horticultural commodities, food
                  crops, plantation products, and livestock from AKOfarm.
                </p>
                <p className="text-body">
                  The work started on doing a UX research for the AKO’s site,
                  such as determining what kind of content that their end-user
                  expected to see in their website, and ended up in creating
                  AKO’s website based on UI design and code using Javascript
                  (React framework).
                </p>
                <p className="text-body">
                  AKO is an early stage company, so I worked side-by-side with
                  the CEO on determining the UI design and delivering UX
                  research result, site prototyping, and mockup directly to him.
                  To bring AKO website to society, I created a “AKO design
                  system” which following the brand guidelines that already
                  existed for easier coding work and consistent UI.
                </p>
                <p className="text-body">
                  We launched AKO earlier than the specified time limit
                  (deadline) and successfully helped the company to increase
                  their company awareness and make their prospective end-user to
                  understand what the company does.
                </p>
              </section>
              <img
                class="akopangan-image kudoku-image mt-10 lg:w-auto lg:h-96"
                src={akopangan}
                alt="akopangan"
              ></img>
            </section>
          </section>
        </section>

        <section className="workHeaderSec px-5 lg:px-20">
          <h1 className="workHeader text-primary text-subhead font-bold">
            Interested more about my work?{" "}
            <Link
              className="underline opacity-50"
              to="/Works"
              smooth
              activeStyle
            >
              Visit the work page
            </Link>
          </h1>
        </section>
      </section>
    </section>
  );
}

export default Work;
